// extracted by mini-css-extract-plugin
export default {"root":"LiveStatus_root__+mrw7"};